import { HomeGroupLayout, ExamResultTable } from 'components';
import React from 'react';


/**
 * 測驗結果頁面
 */

export const HomeExamResultPage = () => {
  return (
    <HomeGroupLayout>
      <ExamResultTable />
    </HomeGroupLayout>
  );
};

HomeExamResultPage.propTypes = {

};


